"use strict";
exports.__esModule = true;
var account_1 = require("../../account");
function getDeviceTransactionConfig(_a) {
    var _b = _a.transaction, votes = _b.votes, resource = _b.resource, mode = _b.mode, account = _a.account, parentAccount = _a.parentAccount, amount = _a.status.amount;
    var mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    var fields = [];
    if (resource) {
        fields.push({
            type: "tron.resource",
            label: "Resource",
            value: resource.slice(0, 1).toUpperCase() + resource.slice(1).toLowerCase()
        });
    }
    if (votes && votes.length > 0) {
        // NB in future if we unify UI with other coin, we could converge to a "votes" top level
        fields.push({
            type: "tron.votes",
            label: "Votes"
        });
    }
    if (!amount.isZero()) {
        fields.push({
            type: "amount",
            label: "Amount"
        });
    }
    if (mode === "freeze") {
        fields.push({
            type: "address",
            label: "Freeze To",
            address: mainAccount.freshAddress
        });
    }
    if (mode === "unfreeze") {
        fields.push({
            type: "address",
            label: "Delegated To",
            address: mainAccount.freshAddress
        });
    }
    if (mode !== "send") {
        fields.push({
            type: "address",
            label: "From Address",
            address: mainAccount.freshAddress
        });
    }
    return fields;
}
exports["default"] = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map